import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'arm-mat-error',
  templateUrl: './arm-mat-error.component.html',
  styleUrls: ['./arm-mat-error.component.scss']
})
export class ArmMatErrorComponent implements OnInit {

  @Input() message;
  @Input() bold;
  @Input() enable;

  constructor() { }

  ngOnInit(): void {
  }

}
